





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IBlock, ISortParameters, ITransaction } from "../../interfaces";
import TransactionService from "@/services/transaction";

@Component({
  computed: {
    ...mapGetters("ui", ["smartbridgeFilter"]),
  },
})
export default class BlockTransactions extends Vue {
  @Prop({ required: true }) public block: IBlock;

  public transactions: ITransaction[] | null = null;
  private meta: any | null = null;
  private smartbridgeFilter: string;

  get sortParams(): ISortParameters {
    return this.$store.getters["ui/transactionSortParams"];
  }

  set sortParams(params: ISortParameters) {
    this.$store.dispatch("ui/setTransactionSortParams", {
      field: params.field,
      type: params.type,
    });
  }

  @Watch("block")
  public onBlockChanged() {
    this.resetTransactions();
    this.getTransactions();
  }

  @Watch("smartbridgeFilter")
  public onSmartbridgeFilterChanged() {
    if (this.smartbridgeFilter !== "hidden") {
      this.getTransactions();
    }
  }

  public mounted() {
    this.resetTransactions();
    this.getTransactions();
  }

  private resetTransactions(): void {
    this.transactions = null;
  }

  private async getTransactions(): Promise<void> {
    if (!this.block.id) {
      return;
    }

    if (this.block.transactions) {
      const { data, meta } = await TransactionService.byBlock(this.block.id);
      this.transactions = data.map((transaction: ITransaction) => ({ ...transaction, price: null }));
      this.meta = meta;
    }
  }

  private onSortChange(params: ISortParameters): void {
    this.sortParams = params;
  }
}
